import StorageExpiry from "./Data/StorageExpiry";

export default class StorageWithExpiryUtility {
    
    private static ExpiryKey(originalKey: string) : string {
        return `${originalKey}__expiry`;
    }
    
    public static ReadLocalStorageExpiry(expiryKey : string) : StorageExpiry | null {
        const value = localStorage.getItem(expiryKey);
        if (value == null) return null;
        const parsed = JSON.parse(value);
        let result = parsed as StorageExpiry;
        if(typeof result === "object") {
            return result;
        }else{
            return null;
        }
    }
    
    public static ReadLocalStorage<T>(key : string) : T | null {
        const expiryKey = StorageWithExpiryUtility.ExpiryKey(key);
        const expiry = StorageWithExpiryUtility.ReadLocalStorageExpiry(expiryKey);
        if(expiry == null || expiry.expiry < Date.now()){
            localStorage.removeItem(key);
            localStorage.removeItem(expiryKey);
            return null;
        }
        const value = localStorage.getItem(key);
        if(!value) return null;
        return JSON.parse(value);
    }
    
    /**
     * Sets the local state with an expiration
     * @param key - Local storage key to store against
     * @param data - The object to stringify & store
     * @param ttl - Time to Live (in ms)
     */
    public static SetLocalStorage<T>(key : string, data : T, ttl : number) : T {
        localStorage.setItem(key, JSON.stringify(data));
        const expiry = Date.now() + ttl;
        const expiryKey = StorageWithExpiryUtility.ExpiryKey(key);
        localStorage.setItem(expiryKey, JSON.stringify({
            expiry: expiry,
            ttl: ttl,
            setTime: Date.now()
        }));
        return data;
    }
}